
import { useNavigate } from "react-router-dom";
import { useUserInvitation } from "@/hooks/useUserInvitation";
import CustomSidebar from "@/components/dashboard/CustomSidebar";
import InvitationAccept from "@/components/user-invitation/InvitationAccept";
import InvitationHeader from "@/components/user-invitation/InvitationHeader";
import InvitationForm from "@/components/user-invitation/InvitationForm";

const UserInvitation = () => {
  const navigate = useNavigate();
  const { 
    token, 
    user, 
    emailList, 
    setEmailList, 
    isLoading,
    organizations, 
    selectedOrgId, 
    setSelectedOrgId,
    selectedOrg, 
    remainingInvites, 
    pendingInvites,
    activePage, 
    setActivePage,
    handleSubmitInvitations 
  } = useUserInvitation();

  const handleSignOut = async (): Promise<void> => {
    // Return a resolved promise to match the expected type
    navigate('/login');
    return Promise.resolve();
  };

  const handleInviteUser = () => {
    // This function is empty in the original code
  };

  if (token) {
    return <InvitationAccept token={token} />;
  }

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="flex h-screen bg-pastel-blue-light dark:bg-[#121624] text-gray-900 dark:text-gray-100 transition-colors">
      <CustomSidebar 
        userName={user?.user_metadata?.name || "Utilisateur"}
        activePage={activePage} 
        setActivePage={setActivePage} 
        handleSignOut={handleSignOut} 
        handleInviteUser={handleInviteUser} 
      />
      
      <div className="flex-1 overflow-auto">
        <div className="container mx-auto py-8 px-4 max-w-4xl">
          <InvitationHeader onBack={handleBack} />

          <InvitationForm 
            organizations={organizations}
            selectedOrgId={selectedOrgId}
            onSelectOrg={setSelectedOrgId}
            isLoading={isLoading}
            selectedOrg={selectedOrg}
            remainingInvites={remainingInvites}
            emailList={emailList}
            setEmailList={setEmailList}
            pendingInvites={pendingInvites}
            handleSubmitInvitations={handleSubmitInvitations}
          />
        </div>
      </div>
    </div>
  );
};

export default UserInvitation;
